import { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'hocs'
import { getBaseUrl } from 'utils/api'
import { AgGridReact } from 'ag-grid-react'
import { AddProposalModalContainer } from 'components/common/modals/AddProposalModalContainer'
import * as ACT from './actions'
import '!style-loader!css-loader!ag-grid-community/dist/styles/ag-grid.css' // eslint-disable-line
import '!style-loader!css-loader!ag-grid-community/dist/styles/ag-theme-balham.css' // eslint-disable-line
import '!style-loader!css-loader!styles/overrides/ag-grid.css' // eslint-disable-line
import { TableContainer, If, RangeDatePicker } from 'components/ideal-core-ui'
import { ProposalFileCellRenderer } from 'components/common/TableColumns/fileColumn/ProposalFileCellRenderer'
import { NameCellRenderer } from './nameColumn/NameCellRenderer'
import { DealNameCellRenderer } from './dealNameColumn/DealNameCellRenderer'
import { ClientCellRenderer } from './clientColumn/ClientCellRenderer'
import { ValueCellRenderer } from './valueColumn/ValueCellRenderer'
import moment from 'moment'
import {
  fromConstantPropertyToSelectValue,
  proposalTasksMapper,
  toProposalsBoardData,
  toProposalsListData
} from 'utils/serializers'
import { preventDefault, timezoneDate, utcDate, utcCurrentDate } from 'utils/helpers'
import { LaneHeader } from 'components/common/LaneHeader'
import { DraggableBoard } from 'components/common/DraggableBoard'
import { SwitchView } from 'components/common/SwitchView'
import { ProposalCard } from 'components/common/ProposalCard'
import { ScheduleTaskModal } from 'components/common/modals/ScheduleTaskModal'
import { TasksModal } from 'components/common/modals/TasksModal'
import { toUsersSelect } from 'components/Users/serializers'
import { createSelector } from 'reselect'
import s from './ProposalsContainer.scss'
import { PageTitle } from 'components/common/PageTitle'
import { FaPlusCircle } from 'react-icons/fa'
import cn from 'classnames'
import { Button } from 'reactstrap'
import Cookies from 'universal-cookie'
import { isAdmin, getUser } from 'utils/authService'
import Select from 'react-select'
import { COOKIES } from 'utils/constants'

const proposalsSelector = state => state.rowData
const boardDataSelector = createSelector([proposalsSelector], rowData => {
  return toProposalsBoardData(rowData)
})

const usersSelector = state => state.users
const listDataSelector = createSelector([proposalsSelector, usersSelector], (rowData, users) => {
  return toProposalsListData(users.users, rowData)
})

const tasksSelector = state => state.tasks
const proposalSelector = state => state.proposal
const proposalTasksSelector = createSelector(
  [tasksSelector, proposalSelector],
  (tasks, proposal) => {
    return proposalTasksMapper(tasks, proposal)
  }
)

const cookies = new Cookies()

@withRouter
@connect(({ proposals, users, proposal }) => {
  const { rowData, paginatedBoard } = proposals
  return {
    rowData,
    boardData: boardDataSelector({ rowData }),
    listData: listDataSelector({ rowData, users }),
    paginatedBoard,
    users: toUsersSelect(users.users),
    proposalTasks: proposalTasksSelector({ tasks: proposal.tasks, proposal: proposal.name })
  }
})
class ProposalsContainer extends Component {
  state = {
    boardView: true,
    listView: false,
    showScheduleTaskModal: false,
    selectedProposal: null,
    showTasksModal: false,
    editTasksModal: false,
    task: null,
    showAddProposalModal: false,
    filters: {
      startDate: utcCurrentDate(null, true).subtract(2, 'weeks').format(),
      endDate: utcCurrentDate(null, true).add(6, 'weeks').format()
    },
    pagination: {},
    filteredByUser: {
      value: getUser().id,
      label: getUser().name
    }
  }

  async componentDidMount() {
    await this.setActiveTab()
    this.getProposals()
    this.getUsers()
  }

  componentDidUpdate(prevProps, prevState) {
    const sessionDateRangeFilters = cookies.get(COOKIES.DATE_RANGE_FILTERS)
    const sessionUsersFilter = cookies.get(COOKIES.USERS_FILTERS)

    if (
      prevState.boardView !== this.state.boardView ||
      prevState.listView !== this.state.listView
    ) {
      this.getProposals()
    }
    if (
      sessionDateRangeFilters &&
      (sessionDateRangeFilters.startDate !== prevState.filters.startDate ||
        sessionDateRangeFilters.endDate !== prevState.filters.endDate)
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        filters: sessionDateRangeFilters,
        pagination: {}
      })
    }
    if (
      sessionUsersFilter &&
      sessionUsersFilter.filteredByUser.value !== prevState.filteredByUser.value
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        filteredByUser: sessionUsersFilter.filteredByUser
      })
    }
  }

  getProposals = () => {
    const { filteredByUser } = this.state

    if (this.state.boardView) {
      if (filteredByUser.value !== -1) {
        this.filterBoardProposalsByUser(filteredByUser.value)
      } else {
        this.props.dispatch({
          type: ACT.PROPOSALS_BOARD_ROW_DATA_FETCH_REQUESTED,
          payload: {
            filters: this.state.filters
          }
        })
      }
    } else if (this.state.listView) {
      if (filteredByUser.value !== -1) {
        this.filterListProposalsByUser(filteredByUser)
      } else {
        this.props.dispatch({
          type: ACT.PROPOSALS_ROW_DATA_FETCH_REQUESTED
        })
      }
    }
  }

  getUsers = () => {
    this.props.dispatch({
      type: ACT.USERS_FETCH_REQUESTED
    })
  }

  setActiveTab = () => {
    const hash = this.props.router.location.hash?.substr(1) || 'board'
    this.changeView(hash)
  }

  changeView = view => {
    this.setState({
      boardView: view === 'board',
      listView: view === 'list'
    })
    const { location } = this.props.router
    this.props.router.navigate(`${location.pathname}#${view}`)
  }

  columnDefs = [
    {
      headerName: 'File',
      cellClass: 'file-column',
      cellRendererFramework: ProposalFileCellRenderer,
      cellRendererParams: {
        path: 'proposals',
        fileUrl: getBaseUrl('/v1/test/get-s3-object')
      },
      suppressSizeToFit: true,
      resizable: false,
      enableRowGroup: false
    },
    {
      headerName: 'Name',
      field: 'name',
      cellClass: 'deals-name-column',
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: {
        path: 'proposals',
        innerRendererFramework: NameCellRenderer
      }
    },
    {
      headerName: 'Due Date',
      field: 'dueDate',
      cellRenderer: data => {
        return data && data.value ? timezoneDate(data.value) : ''
      }
    },
    {
      headerName: 'Client',
      valueGetter: params => {
        if (!params.data || !params.data.company) return ''
        const { name } = params.data.company
        return name
      },
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: {
        path: 'companies',
        innerRendererFramework: ClientCellRenderer
      }
    },
    {
      headerName: 'Status',
      valueGetter: params => {
        if (!params || !params.data) return ''
        return params.data.status
          ? fromConstantPropertyToSelectValue(params.data.status, 'ProposalStatus')?.label
          : ''
      },
      valueFormatter: params => {
        if (!params.value) return ''
        return fromConstantPropertyToSelectValue(params.value, 'ProposalStatus')?.label
      },
      field: 'status',
      cellClass: 'capitalize-column-content'
    },
    {
      headerName: 'Follow-up Date',
      field: 'followUpDate',
      cellRenderer: data => {
        return data && data.value ? timezoneDate(data.value) : ''
      }
    },
    {
      headerName: 'Assignee',
      valueGetter: params => {
        if (!params.data || !params.data.assignee) return ''
        const { firstName, lastName } = params.data.assignee
        return firstName + ' ' + lastName
      },
      cellClass: 'deals-name-column',
      cellRenderer: 'agGroupCellRenderer'
    },
    {
      headerName: 'Opportunity Name',
      valueGetter: params => {
        if (!params.data || !params.data.deal) return ''
        return params.data.deal.name
      },
      cellClass: 'deals-name-column',
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: {
        path: 'opportunities',
        innerRendererFramework: DealNameCellRenderer
      }
    },
    {
      headerName: 'Street Address',
      field: 'deal.address'
    },
    {
      headerName: 'City',
      field: 'deal.city'
    },
    {
      headerName: 'State',
      field: 'deal.state'
    },
    {
      headerName: 'Value',
      field: 'value',
      cellRendererFramework: ValueCellRenderer
    },
    {
      headerName: 'Date Created',
      field: 'createdAt',
      cellRenderer: data => {
        return data && data.value ? timezoneDate(data.value) : ''
      }
    },
    {
      headerName: 'Created By',
      field: 'createdBy',
      cellClass: 'deals-name-column',
      cellRenderer: data => data?.value?.name
    },
    {
      headerName: 'Date Last Modified',
      field: 'updatedAt',
      cellRenderer: data => {
        return data && data.value ? timezoneDate(data.value) : ''
      }
    }
  ]

  changeStatus = (status, proposal) => {
    this.props.dispatch({
      type: ACT.PROPOSAL_UPDATE_STATUS_REQUESTED,
      payload: {
        id: proposal.id,
        status,
        oldStatus: proposal.status,
        filters: this.state.filters,
        pagination: this.state.pagination
      }
    })
  }

  toggleScheduleTaskModal = (proposal, status, params = {}) => {
    this.setState(prevState => ({
      showScheduleTaskModal: !prevState.showScheduleTaskModal,
      editTasksModal: !!params.edit,
      task: params.task || null,
      selectedProposal: {
        ...proposal,
        status
      }
    }))
  }

  createTask = task => {
    const { status, id } = this.state.selectedProposal
    this.props.dispatch({
      type: ACT.CREATE_PROPOSAL_BOARD_TASK_REQUESTED,
      payload: {
        task,
        proposalId: id,
        proposalStatus: status
      }
    })
  }

  toggleTasksModal = () => {
    this.setState(prevState => ({
      showTasksModal: !prevState.showTasksModal
    }))
  }

  showScheduleTaskModal = (params = {}) => {
    const { selectedProposal } = this.state
    this.toggleTasksModal()
    this.toggleScheduleTaskModal(selectedProposal, selectedProposal.status, params)
  }

  showTasksModal = (event, id, status, name) => {
    const { rowData } = this.props
    preventDefault(event)

    this.props.dispatch({
      type: ACT.PROPOSAL_TASKS_FETCH_REQUESTED,
      payload: {
        id,
        name
      }
    })
    this.setState(prevState => ({
      showTasksModal: !prevState.showTasksModal,
      selectedProposal: rowData[status].filter(proposal => proposal.id === id)[0]
    }))
  }

  updateTask = task => {
    const { status, id } = this.state.selectedProposal
    this.props.dispatch({
      type: ACT.UPDATE_BOARD_PROPOSAL_TASK_REQUESTED,
      payload: {
        task,
        proposalId: id,
        proposalStatus: status
      }
    })
  }

  deleteTask = task => {
    const { status, id } = this.state.selectedProposal
    this.props.dispatch({
      type: ACT.DELETE_BOARD_PROPOSAL_TASK_REQUESTED,
      payload: {
        task,
        proposalId: id,
        proposalStatus: status
      }
    })
  }

  markTaskAsDone = id => {
    const { selectedProposal } = this.state
    this.props.dispatch({
      type: ACT.PROPOSAL_BOARD_TASK_MARK_COMPLETED_REQUESTED,
      payload: {
        id,
        proposalStatus: selectedProposal.status,
        proposalId: selectedProposal.id
      }
    })
  }

  markTaskAsNotDone = id => {
    const { selectedProposal } = this.state
    this.props.dispatch({
      type: ACT.PROPOSAL_BOARD_TASK_MARK_NOT_COMPLETED_REQUESTED,
      payload: {
        id,
        proposalStatus: selectedProposal.status,
        proposalId: selectedProposal.id
      }
    })
  }

  toggleAddProposalModal = () => {
    this.setState(prevState => ({
      showAddProposalModal: !prevState.showAddProposalModal
    }))
  }

  setDateFilters = dates => {
    this.setState(
      {
        filters: {
          startDate: utcDate(dates.from),
          endDate: utcDate(dates.to)
        }
      },
      () => {
        this.getProposals()
      }
    )
  }

  setPagination = (laneId, requestedPage) => {
    this.setState(
      {
        pagination: {
          ...this.state.pagination,
          [laneId]: requestedPage
        }
      },
      () => {
        this.props.dispatch({
          type: ACT.UPDATE_PROPOSAL_PAGINATION_BOARD,
          payload: {
            pagination: this.state.pagination
          }
        })
      }
    )
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve()
      }, 100)
    })
  }

  onLaneScroll = (requestedPage, laneId) => {
    let page = this.state.pagination[laneId] || 2
    if (this.state.pagination[laneId]) {
      page = page + 1
    }
    return this.setPagination(laneId, page)
  }

  filterBoardProposalsByUser = id => {
    this.props.dispatch({
      type: ACT.PROPOSALS_BOARD_FOR_USER_FETCH_REQUESTED,
      payload: {
        userId: id,
        filters: this.state.filters
      }
    })
  }

  filterListProposalsByUser = user => {
    this.props.dispatch({
      type: ACT.PROPOSALS_LIST_FOR_USER_FETCH_REQUESTED,
      payload: {
        userId: user.value
      }
    })
  }

  render() {
    const {
      boardView,
      showScheduleTaskModal,
      selectedProposal,
      showTasksModal,
      editTasksModal,
      task,
      showAddProposalModal,
      filters,
      filteredByUser
    } = this.state
    const { paginatedBoard, listData, users, proposalTasks } = this.props
    const addProposalActionType = boardView
      ? filteredByUser.value !== -1
        ? ACT.PROPOSALS_BOARD_FOR_USER_FETCH_REQUESTED
        : ACT.PROPOSALS_BOARD_ROW_DATA_FETCH_REQUESTED
      : filteredByUser.value !== -1
        ? ACT.PROPOSALS_LIST_FOR_USER_FETCH_REQUESTED
        : ACT.PROPOSALS_ROW_DATA_FETCH_REQUESTED
    return (
      <>
        <PageTitle view="Proposals" />
        <section className={s.topWrapper}>
          <Button className={cn(s.addProposalBtn, s.addBtn)} onClick={this.toggleAddProposalModal}>
            <FaPlusCircle />
            Add Proposal
          </Button>
          {isAdmin() && (
            <Select
              onChange={value => {
                if (this.state.boardView) {
                  this.filterBoardProposalsByUser(value.value)
                } else {
                  this.filterListProposalsByUser(value)
                }
                this.setState(
                  {
                    filteredByUser: value,
                    pagination: {}
                  },
                  () => {
                    cookies.set(
                      COOKIES.USERS_FILTERS,
                      {
                        filteredByUser: value
                      },
                      {
                        path: '/',
                        expires: moment().add(8, 'weeks').toDate()
                      }
                    )
                  }
                )
              }}
              options={[
                {
                  value: -1,
                  label: 'All Users'
                },
                ...this.props.users
              ]}
              value={this.state.filteredByUser}
              className={s.userSelect}
            />
          )}
          <AddProposalModalContainer
            addProposalActionType={addProposalActionType}
            showAddProposalModal={showAddProposalModal}
            toggleAddProposalModal={this.toggleAddProposalModal}
            filters={filters}
            filteredByUser={filteredByUser}
          />
          {this.state.boardView && (
            <RangeDatePicker
              startDate={this.state.filters.startDate}
              endDate={this.state.filters.endDate}
              onChange={this.setDateFilters}
            />
          )}
          <SwitchView isBoardView={boardView} changeView={this.changeView} />
        </section>
        <If
          condition={boardView}
          fallback={
            (Array.isArray(listData) && (
              <TableContainer canSaveAsList tableKey="proposal" selectable>
                {gridData => (
                  <AgGridReact {...gridData} columnDefs={this.columnDefs} rowData={listData} />
                )}
              </TableContainer>
            )) ||
            null
          }
        >
          <div className={s.boardWrapper}>
            <DraggableBoard
              onLaneScroll={this.onLaneScroll}
              onDragEnd={this.changeStatus}
              data={paginatedBoard}
              customLaneHeader={<LaneHeader dataType="proposal" />}
            >
              <ProposalCard showTasksModal={this.showTasksModal} />
            </DraggableBoard>
          </div>
        </If>
        <If condition={showScheduleTaskModal}>
          <ScheduleTaskModal
            showScheduleTaskModal={showScheduleTaskModal}
            toggleScheduleTaskModal={this.toggleScheduleTaskModal}
            createTask={this.createTask}
            updateTask={this.updateTask}
            users={users}
            proposal={selectedProposal}
            edit={editTasksModal}
            selectedTask={task}
            markAsDone={this.markTaskAsDone}
            markAsNotDone={this.markTaskAsNotDone}
            deleteTask={this.deleteTask}
          />
        </If>
        <If condition={showTasksModal}>
          <TasksModal
            title={selectedProposal && `Active Tasks for ${selectedProposal.name}`}
            showScheduleTaskModal={this.showScheduleTaskModal}
            showTasksModal={showTasksModal}
            toggleTasksModal={this.toggleTasksModal}
            tasks={proposalTasks}
            markAsDone={this.markTaskAsDone}
            markAsNotDone={this.markTaskAsNotDone}
          />
        </If>
      </>
    )
  }
}

export default ProposalsContainer
